/* UNO Brand – Interaktionen für sections/uno-brand-*.liquid */
(function () {
  function initSlider(root) {
    var track = root.querySelector('.single-slider__track');
    var thumbs = root.querySelectorAll('.single-navigation__item');
    if (!track || !thumbs.length) return;
    function setActive(i) { thumbs.forEach(function (t, n) { t.classList.toggle('active', n === i); }); }
    var strip = root.querySelector('.single-navigation');
    var cur = 0, n = thumbs.length;
    function go(i) {
      cur = Math.max(0, Math.min(n - 1, i));
      track.scrollTo({ left: (track.clientWidth + 10) * cur, behavior: 'smooth' });
      setActive(cur);
    }
    function upd() {
      root.querySelectorAll('[data-slide="-1"]').forEach(function (b) { b.disabled = cur <= 0; });
      root.querySelectorAll('[data-slide="1"]').forEach(function (b) { b.disabled = cur >= n - 1; });
      if (strip) {
        var t = thumbs[cur]; if (t) strip.scrollTo({ left: Math.max(0, t.offsetLeft - strip.clientWidth / 2 + t.clientWidth / 2), behavior: 'smooth' });
        var max = strip.scrollWidth - strip.clientWidth - 2;
        root.querySelectorAll('[data-thumbs="-1"]').forEach(function (b) { b.disabled = strip.scrollLeft <= 2; });
        root.querySelectorAll('[data-thumbs="1"]').forEach(function (b) { b.disabled = strip.scrollLeft >= max; });
      }
    }
    var _setActive = setActive;
    setActive = function (i) { cur = i; _setActive(i); upd(); };
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    root.querySelectorAll('[data-slide]').forEach(function (b) { b.addEventListener('click', function () { go(cur + Number(b.getAttribute('data-slide'))); }); });
    root.querySelectorAll('[data-thumbs]').forEach(function (b) { b.addEventListener('click', function () { strip.scrollBy({ left: strip.clientWidth * 0.8 * Number(b.getAttribute('data-thumbs')), behavior: 'smooth' }); }); });
    if (strip) strip.addEventListener('scroll', function () {
      var max = strip.scrollWidth - strip.clientWidth - 2;
      root.querySelectorAll('[data-thumbs="-1"]').forEach(function (b) { b.disabled = strip.scrollLeft <= 2; });
      root.querySelectorAll('[data-thumbs="1"]').forEach(function (b) { b.disabled = strip.scrollLeft >= max; });
    }, { passive: true });
    var timer;
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { var i = Math.round(track.scrollLeft / (track.clientWidth + 10)); if (i !== cur) setActive(i); }, 80);
    }, { passive: true });
    upd();
  }

  function initCarouselNav(root) {
    root.querySelectorAll('[data-unob-carousel]').forEach(function (wrap) {
      var sc = wrap.querySelector('.hscroll');
      wrap.querySelectorAll('[data-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var item = sc.firstElementChild; var step = item ? item.getBoundingClientRect().width + 25 : 300;
          sc.scrollBy({ left: step * Number(b.getAttribute('data-dir')), behavior: 'smooth' });
        });
      });
    });
  }

  function initVideos(root) {
    root.querySelectorAll('[data-yt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-yt');
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
        f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        f.allowFullscreen = true;
        f.title = btn.getAttribute('aria-label') || 'Video';
        btn.parentNode.appendChild(f);
        btn.remove();
      });
    });
  }

  function initMore(root) {
    root.querySelectorAll('[data-unob-more]').forEach(function (btn) {
      var c = document.getElementById(btn.getAttribute('aria-controls'));
      if (!c) return;
      if (c.scrollHeight <= 300) { btn.parentNode.hidden = true; c.classList.remove('is-collapsed'); return; }
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        c.classList.toggle('is-collapsed', open);
        btn.querySelector('span').textContent = open ? btn.getAttribute('data-more') : btn.getAttribute('data-less');
      });
    });
  }


  /* Anker #emotionen: Abstand zum fixierten Shop-Header, damit das Foto komplett sichtbar ist */
  function headerH() {
    var h = document.querySelector('.section-header, sticky-header, header.header');
    return h ? Math.round(h.getBoundingClientRect().height) : 0;
  }
  function setHeaderVar() { document.documentElement.style.setProperty('--unob-header', headerH() + 'px'); }
  function scrollToAnchor(id, smooth) {
    var el = document.getElementById(id);
    if (!el) return false;
    setHeaderVar();
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerH();
    window.scrollTo({ top: Math.max(0, top), behavior: smooth ? 'smooth' : 'auto' });
    return true;
  }
  function initAnchors() {
    var st = document.createElement('style'); st.textContent = '.unob .emotion{scroll-margin-top:var(--unob-header,80px)}.unob .emotion__full{display:block;height:calc(100vh - var(--unob-header,0px));height:calc(100svh - var(--unob-header,0px))}'; document.head.appendChild(st);
    setHeaderVar();
    window.addEventListener('resize', setHeaderVar, { passive: true });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#emotionen"]');
      if (!a) return;
      var url = new URL(a.href, location.href);
      if (url.pathname !== location.pathname) return;
      if (scrollToAnchor('emotionen', true)) { e.preventDefault(); history.replaceState(null, '', '#emotionen'); }
    });
    if (location.hash === '#emotionen') {
      var go = function () { scrollToAnchor('emotionen', false); };
      setTimeout(go, 50); window.addEventListener('load', function () { setTimeout(go, 50); });
    }
  }

  function init(root) { initSlider(root); initCarouselNav(root); initVideos(root); initMore(root); }
  function boot() { document.querySelectorAll('.unob').forEach(init); }
  function start() { boot(); initAnchors(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.unob'); if (r) init(r); });
})();
